import React from 'react';
import Pagination from './Pagination'; // استيراد الترقيم
import { useTranslation } from '../../context/I18nContext';

const DataTable = ({
  columns, 
  data, 
  sortConfig, 
  onSort, 
  renderActions, 
  mobileRender,
  // إضافة خصائص الترقيم
  paginationConfig
}) => {
  const { t } = useTranslation('common');

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
      {/* Desktop View (Table) */}
      <div className="hidden md:block">
        {/* text-start بدل text-left عشان محاذاة النص تتقلب تلقائيًا مع اتجاه اللغة */}
        <table className="w-full text-start border-collapse">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th
                  key={col.key}
                  onClick={() => onSort(col.key)}
                  className={`p-4 font-semibold text-xs uppercase cursor-pointer
                    transition-all duration-200 select-none text-white
                    hover:brightness-110
                    ${index === 0 ? 'rounded-ss-xl' : ''}`}
                  style={{ backgroundColor: "var(--primary-color)" }}
                >
                  <div className="flex items-center gap-1">
                    {col.label}
                    <span className="ms-1 opacity-70">
                      {sortConfig.key === col.key && (sortConfig.direction === "asc" ? " ↑" : " ↓")}
                    </span>
                  </div>
                </th>
              ))}
              {/* rounded-ss-xl/rounded-se-xl بدل rounded-tl-xl/rounded-tr-xl:
                  الجدول نفسه بياخد اتجاهه من الصفحة (dir موروثة)، وفي RTL
                  ترتيب أعمدة الـ <table> بيتقلب بصريًا تلقائيًا (أول عمود في
                  الـ DOM بيتعرض على اليمين بدل الشمال) — فلازم زوايا الاستدارة
                  تتقلب معاه بنفس المنطق، عشان تفضل مطابقة لزوايا الحاوية
                  المستديرة (rounded-2xl) اللي لفة الجدول كله. */}
              <th
                className="p-4 text-center text-xs uppercase text-white rounded-se-xl"
                style={{ backgroundColor: "var(--primary-color)" }}
              >
                {t("table_actions_header", "Actions")}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length + 1} className="p-10 text-center text-gray-400 italic">
                  {t("table_no_data", "No data available.")}
                </td>
              </tr>
            ) : (
              data.map((row, i) => (
                <tr key={row.id || i} className={`${i % 2 !== 0 ? 'bg-gray-50/40' : 'bg-white'} hover:bg-gray-50 transition-colors`}>
                  {columns.map((col) => (
                    <td key={col.key} className={`p-4 text-sm ${col.className || "text-gray-700 font-medium"}`}>
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                  <td className="p-4">
                    <div className="flex justify-center gap-2">
                      {renderActions(row)}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile View (Cards) */}
      <div className="grid grid-cols-1 gap-4 p-4 md:hidden">
        {data.length === 0 ? (
          <p className="text-center text-gray-400 py-10 italic">{t("table_no_data_mobile", "No data found.")}</p>
        ) : (
          data.map((row, i) => (
            <div key={row.id || i} className="border border-gray-100 rounded-xl p-4 bg-gray-50/30 shadow-sm">
              {mobileRender(row)}
              <div className="flex gap-2 border-t border-gray-100 pt-3 mt-3">
                {renderActions(row, true)}
              </div>
            </div>
          ))
        )}
      </div>
      {paginationConfig && (
        <Pagination 
          currentPage={paginationConfig.currentPage}
          totalPages={paginationConfig.totalPages}
          onPageChange={paginationConfig.onPageChange}
          totalItems={paginationConfig.totalItems}
          currentCount={data.length}
        />
      )}
    </div>
  );
};

export default DataTable;